import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How do I pay?",
    a: (
      <>
        You lock your yacht with a $500 non-refundable deposit today. The
        remaining balance is paid on the day of your charter — in cash, or
        another payment arrangement made with our team.{" "}
        <strong>The deposit is applied toward your total, not added on top.</strong>{" "}
        For example: if your total is $2,500, you pay $500 now and $2,000 on
        the day of your charter.
      </>
    ),
  },
  {
    q: "So if my total is $3,500 how much do I pay upfront?",
    a: "You pay a $500 deposit upfront to lock the yacht. On the day of your charter you pay the remaining $3,000. Total is still $3,500 — the deposit is included, not extra.",
  },
  {
    q: "Can I get my deposit back if I cancel?",
    a: "The $500 deposit is non-refundable. If you need to cancel or reschedule, please contact us — we handle exceptional cases (weather, mechanical issues) on a case-by-case basis.",
  },
  {
    q: "What's included in a charter?",
    a: "A fully private yacht with captain, standard amenities (sun deck, on-board bathroom, Bluetooth sound system), and a dedicated HBE contact from booking through disembarking.",
  },
  {
    q: "What's the minimum duration?",
    a: "Four hours. You can extend as many hours as fit within the day.",
  },
  {
    q: "How far in advance can I book?",
    a: "Up to six months out. Bookings must start at least 24 hours from now.",
  },
  {
    q: "Where do we depart from?",
    a: "Miami. Exact marina and departure details are provided once your deposit is captured and the reservation is confirmed.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="hbe-container py-16 md:py-24 max-w-3xl" data-testid="faq-page">
      <div className="hbe-eyebrow">FAQ</div>
      <h1 className="mt-3 font-serif text-4xl md:text-5xl">
        Answers to what's most asked.
      </h1>

      <div className="mt-10 divide-y divide-hbe-line border-y border-hbe-line">
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.q}>
              <button
                type="button"
                className="w-full py-5 flex items-center justify-between text-left"
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                data-testid={`faq-q-${i}`}
              >
                <span className="font-serif text-lg md:text-xl pr-4">{f.q}</span>
                <ChevronDown
                  size={20}
                  className={`shrink-0 text-hbe-primary transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              {isOpen && (
                <div
                  className="pb-6 text-hbe-ink/80 leading-relaxed"
                  data-testid={`faq-a-${i}`}
                >
                  {f.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
